export const BI_PAGE_MEMBERS_POSTS = 'members-posts';
export const BI_PAGE_MEMBERS_DRAFTS = 'members-drafts';
export const BI_PAGE_MEMBERS_LIKES = 'members-likes';
export const BI_PAGE_MEMBERS_COMMENTS = 'members-comments';
